// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1sPjC","title":"Header_title__1_NiL","left":"Header_left__3csia","clinicName":"Header_clinicName__3MoBK"};